import React from "react";
import MultiSelect from "./FilterTypes/MultiSelect";
import { v4 as uuidv4 } from "uuid";
import type Category from "../../models/Category";

export type SubCategoryFilterPageProps = {
	t: any,
	subCategory: Category,
	setFilter: string => void,
	isValueSelected: string => boolean,
};

const FilterPageSubCategory = (props: SubCategoryFilterPageProps) => {
	return <React.Fragment>
		<MultiSelect
			infoText={props.subCategory.count} label={props.t("sort.all")}
			value={props.subCategory.name} key={uuidv4()}
			setFilter={props.setFilter} selected={props.isValueSelected(props.subCategory.name)}
		/>
		{props.subCategory && props.subCategory.categories.map(subCat => {
			return (
				<MultiSelect infoText={subCat.count} label={subCat.title}
							 value={subCat.name} key={uuidv4()} useLargeLabel={true}
							 setFilter={props.setFilter} selected={props.isValueSelected(subCat.name)}
				/>);
		})}
	</React.Fragment>;
};

export default FilterPageSubCategory;
